/**
 * @generated SignedSource<<eea45e600a192e5f43df5357a52b529c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ClientEventSignUpAccess = "ALREADY_IN_SERIES" | "CLOSED" | "COMPLETE" | "DRAFT" | "FULL" | "PENDING" | "SIGNUP_AVAILABLE" | "UNAVAILABLE" | "WAITLIST_AVAILABLE";
export type ClientEventSignUpStatus = "CHECKED_IN" | "CONFIRMED" | "NONE" | "WAITLIST";
export type CustomColor = "A" | "B" | "C" | "D" | "E" | "F";
export type DepartmentType = "AQUATICS" | "AXE_THROWING" | "BASKETBALL" | "BOATING" | "BOCCE_BALL" | "BUSINESS" | "CARD_ROOM" | "CLUB" | "CROQUET" | "DINING" | "FITNESS" | "GOLF" | "HOCKEY" | "RACQUET" | "SALON" | "SHUFFLEBOARD" | "SPA";
import { FragmentRefs } from "relay-runtime";
export type EventCardWrapper$data = {
  readonly accessStatusForClient: ClientEventSignUpAccess | null | undefined;
  readonly clientEligibleSignUpWindows: ReadonlyArray<{
    readonly closesAt: string | null | undefined;
    readonly id: string;
    readonly opensAt: string | null | undefined;
  } | null | undefined> | null | undefined;
  readonly endOn: string;
  readonly eventSeries: {
    readonly color: CustomColor;
    readonly facility: {
      readonly copyOverrides: {
        readonly course: {
          readonly plural: string;
        } | null | undefined;
      };
      readonly department: {
        readonly name: string;
        readonly type: DepartmentType;
      } | null | undefined;
    };
    readonly image: {
      readonly publicId: string;
    } | null | undefined;
    readonly name: string;
  };
  readonly eventSessions: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly courses: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly courseBucket: {
                readonly name: string;
              } | null | undefined;
              readonly id: string;
              readonly name: string;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly displayTime: string | null | undefined;
        readonly endAt: string | null | undefined;
        readonly startAt: string | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"useEventLocationLabel_Event">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly signUpStatusForClient: ClientEventSignUpStatus | null | undefined;
  readonly spotsAvailable: number | null | undefined;
  readonly startOn: string;
  readonly tags: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly name: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "EventCardWrapper";
};
export type EventCardWrapper$key = {
  readonly " $data"?: EventCardWrapper$data;
  readonly " $fragmentSpreads": FragmentRefs<"EventCardWrapper">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = [
  {
    "kind": "Variable",
    "name": "clientId",
    "variableName": "memberId"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = [
  (v3/*: any*/)
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "memberId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventCardWrapper",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "accessStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "kind": "ScalarField",
      "name": "signUpStatusForClient",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endOn",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spotsAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "EventTagConnection",
      "kind": "LinkedField",
      "name": "tags",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventTagEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventTag",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": (v4/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "tags(first:1000)"
    },
    {
      "alias": null,
      "args": (v2/*: any*/),
      "concreteType": "EventSessionConnection",
      "kind": "LinkedField",
      "name": "eventSessions",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "EventSessionEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EventSession",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "startAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "endAt",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "displayTime",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "CourseConnection",
                  "kind": "LinkedField",
                  "name": "courses",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "CourseEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Course",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v0/*: any*/),
                            (v3/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "CourseBucket",
                              "kind": "LinkedField",
                              "name": "courseBucket",
                              "plural": false,
                              "selections": (v4/*: any*/),
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "useEventLocationLabel_Event"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "eventSessions(first:1000)"
    },
    {
      "alias": null,
      "args": (v1/*: any*/),
      "concreteType": "EventSignUpWindow",
      "kind": "LinkedField",
      "name": "clientEligibleSignUpWindows",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "closesAt",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "opensAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventSeries",
      "kind": "LinkedField",
      "name": "eventSeries",
      "plural": false,
      "selections": [
        (v3/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "color",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Facility",
          "kind": "LinkedField",
          "name": "facility",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "FacilityCopyOverrides",
              "kind": "LinkedField",
              "name": "copyOverrides",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "NounOverride",
                  "kind": "LinkedField",
                  "name": "course",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "plural",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Department",
              "kind": "LinkedField",
              "name": "department",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "type",
                  "storageKey": null
                },
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": "publicId",
              "args": null,
              "kind": "ScalarField",
              "name": "renderingKey",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
})();

(node as any).hash = "17848891f4507b651b0561d8157af04a";

export default node;
